export const US_TIMEZONES: readonly string[] = [
  "America/New_York",
  "America/Detroit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Indiana/Indianapolis",
  "America/Indiana/Marengo",
  "America/Indiana/Vevay",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Winamac",
  "America/Indiana/Vincennes",
  "America/Indiana/Knox",
  "America/Chicago",
  "America/Menominee",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/North_Dakota/Beulah",
  "America/Denver",
  "America/Boise",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Juneau",
  "America/Sitka",
  "America/Metlakatla",
  "America/Yakutat",
  "America/Adak",
  "Pacific/Honolulu",
] as const;

const US_TIMEZONE_SET: ReadonlySet<string> = new Set(US_TIMEZONES);

export function isUSTimezone(tz: string): boolean {
  return US_TIMEZONE_SET.has(tz);
}

interface USRegionGroup {
  label: string;
  zones: string[];
}

export const US_TIMEZONE_REGIONS: USRegionGroup[] = [
  {
    label: "Eastern",
    zones: [
      "America/New_York",
      "America/Detroit",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Indiana/Indianapolis",
      "America/Indiana/Marengo",
      "America/Indiana/Vevay",
      "America/Indiana/Petersburg",
      "America/Indiana/Tell_City",
      "America/Indiana/Winamac",
      "America/Indiana/Vincennes",
      "America/Indiana/Knox",
    ],
  },
  {
    label: "Central",
    zones: [
      "America/Chicago",
      "America/Menominee",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/North_Dakota/Beulah",
    ],
  },
  {
    label: "Mountain",
    zones: ["America/Denver", "America/Boise"],
  },
  {
    label: "Arizona",
    zones: ["America/Phoenix"],
  },
  {
    label: "Pacific",
    zones: ["America/Los_Angeles"],
  },
  {
    label: "Alaska",
    zones: [
      "America/Anchorage",
      "America/Juneau",
      "America/Sitka",
      "America/Metlakatla",
      "America/Yakutat",
    ],
  },
  {
    label: "Hawaii",
    zones: ["America/Adak", "Pacific/Honolulu"],
  },
];
